import { BaseObject, IBaseObject } from './BaseObject';

export interface SousSystemDescription {
  idObjetSousSysteme: number;
  nomSousSysteme: string;
  idObjetCodeReponse: number;
  descriptionCodeReponse: string;
  message: string;
}

export interface IRapportSousSystemeRaw extends IBaseObject {
  nomSousSysteme: string;
  numeroPgm: string;
  descriptionCodeReponse: string;
  message: string;
  descriptionPgm: string;
  commentairePgm: string;
}

export class RapportSousSystemRaw extends BaseObject implements IRapportSousSystemeRaw {
  descriptionCodeReponse!: string;
  message!: string;
  nomSousSysteme!: string;
  numeroPgm!: string;
  descriptionPgm!: string;
  commentairePgm!: string;

  constructor(props?: IRapportSousSystemeRaw) {
    super(props);

    if (props) {
      Object.assign(this, props);
    }
  }
}
